export const Experiments = {
  TrackingEvents: {
    donateButtonClick: 'donateButtonClick',
    shareModalOpen: 'shareModalOpen',
    shareSocialButtonClick: 'shareSocialButtonClick',
  },
  ConsumerFintech: {
    CheckoutConversion: {
      PopupSideBySide: {
        flagKey: 'consumerfintech_jgcheckout_conversion_pop-up_sbs_view_f25',
      },
    },
  },
};
